var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Verletzter",
          },
          on: { save: _vm.saveInjuredFormData },
          scopedSlots: _vm._u(
            [
              _vm.formContext.permissions.canCreateRetroactiveChangesNote ===
              true
                ? {
                    key: "after-icons",
                    fn: function () {
                      return [
                        _c("csp-retroactive-changes-modal", {
                          attrs: {
                            "record-id": _vm.recordId,
                            title: "Verletzter",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm.showChangelogButton
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c("csp-changelog-modal", {
                    attrs: { "changelog-url": _vm.injuredChangelogUrl },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h2", [_vm._v("Stammdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Anrede",
                  property: "gender",
                  required: true,
                  type: "radio",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: _vm.personLabelPrefix + "Titel",
                  property: "title",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: _vm.personLabelPrefix + "Vorname",
                  property: "firstName",
                  required: !_vm.isGenderCompany,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: _vm.personLabelPrefix + "Nachname",
                  property: "lastName",
                  required: !_vm.isGenderCompany,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Firmenname",
                  property: "companyName",
                  required: _vm.isGenderCompany,
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Straße",
                  property: "street",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "PLZ",
                  property: "postalCode",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Ort",
                  property: "place",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Land",
                  "options-loader": _vm.loadCountryOptions,
                  property: "country",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h2", [_vm._v("Kontaktdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Mobil",
                  property: "phone",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Telefon",
                  property: "mobile",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "E-Mail",
                  property: "email",
                  type: "text",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }